import { render, staticRenderFns } from "./administrationReport.vue?vue&type=template&id=53348374&scoped=true&"
import script from "./administrationReport.vue?vue&type=script&lang=js&"
export * from "./administrationReport.vue?vue&type=script&lang=js&"
import style0 from "./administrationReport.vue?vue&type=style&index=0&id=53348374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53348374",
  null
  
)

export default component.exports